/* eslint-disable */

export const pagination = {
  postPerPage: 10
}

export const categories = [
  {
    label: 'news',
    href: '/news'
  },
  {
    label: 'workshop',
    href: '/workshop',
    subCategory: [
      {
        label: 'Maintenance',
        href: '/blog/category/maintenance'
      },
      {
        label: 'Improvements',
        href: '/blog/category/improvements'
      }
    ]
  },
  {
    label: 'q&a',
    href: '/qa'
  }
]
